// extracted by extract-css-chunks-webpack-plugin
module.exports = {"heroWrapper":"registry-discount__heroWrapper__2v9DN","heroImage":"registry-discount__heroImage__2ciix","termsList":"registry-discount__termsList__AaKX1"};